(function ($) {
  'use strict';

  $('.js-person-biography-content-toggle--expand').on('click', function (e) {
    e.preventDefault();

    const $expandBtn = $(this);
    const $person = $expandBtn.closest('.people__person');
    const $content = $person.find('.people__person-content-wrapper');

    $content.slideDown(300);
    $expandBtn.attr('aria-expanded', 'true').hide();
  });

  $('.js-person-biography-content-toggle--close').on('click', function (e) {
    e.preventDefault();

    const $collapseBtn = $(this);
    const $person = $collapseBtn.closest('.people__person');
    const $expandBtn = $person.find('.js-person-biography-content-toggle--expand');
    const $content = $person.find('.people__person-content-wrapper');

    $content.slideUp(300);
    $expandBtn.attr('aria-expanded', 'false').show();
  });

})(jQuery);
